<template>
  <div class="empty">
    <div class="container">
      <h1 class="display-4 text-center">ขออภัย ไม่พบหน้าที่คุณกำลังค้นหา</h1>
      <p class="lead text-center">Sorry, Page not found</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pagenotfound',
  created() {
  },
  methods: {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '@/assets/scss/themes/variables.scss';
.empty {
  // background-color: $gray-200;
  // min-height: calc(100vh - 80px);
  padding-top: 38vh;
}
</style>



// WEBPACK FOOTER //
// src/components/PageNotFound.vue